import config from '@/config'
import axios from 'axios'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000
  })
}

const SettingApi = {
  postConfigDeleteUser: (request) => {
    const { data } = request
    return instance().post('/api/manage-users/config-delete-user', data)
  }
}

export default SettingApi



// WEBPACK FOOTER //
// ./src/api/setting.js